// src/Login.js
import React, { useState } from "react";
import "./login.css";
import { useEffect } from "react";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";
import { useAuth } from "../../utils/authContext";
import { useNavigate } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState("");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const handleValidation = () => {
    const newErrors = {};
    if (!username || username == "")
      newErrors.username = "username is required";
    else if (username.length < 3 || username.length > 50)
      newErrors.username = "username must be 3 to 50 characters long";

    if (!password || password == "")
      newErrors.password = "password is required";
    else if (password.length < 3 || password.length > 50) {
      console.log("password.lengthpassword.length", password.length, password);
      newErrors.password = "Password must be 3 to 50 characters long";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length == 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);
  const handleLogin = () => {
    let flag = handleValidation();
    if (flag) {
      setLoading(true);
      const config={
        headers:{
          'Content-Type':"application/json"
        }
      }
      const payload={ user: username, pass: password }
      axios
        .post(base_url + "/admin-login", payload,config)
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          navigate("/");
          setLoading(false);
          login();
        })
        .catch((err) => {
          console.log("ERROR------------------",err)
          err.password = err?.response?.data?.message;
          setErrors(err);
          setLoading(false);
        });
    }
  };

  return (
    <div className="login-container">
      
      <div className="login-form">
        <h2>Login</h2>
        <div className="input-container-login">
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {errors?.username && (
            <span className="login-errors">{errors?.username}</span>
          )}
        </div>
        <div className="input-container-login">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {errors?.password && (
            <span className="login-errors">{errors?.password}</span>
          )}
        </div>

        {!loading ? (
          <button onClick={handleLogin}>Login</button>
        ) : (
          <div
            style={{
              backgroundColor: "lightgray",
              padding: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius:20
            }}
          >
            <CircularProgress size={15} />
          </div>
        )}
        <button
          onClick={() => navigate("/forgot-password")}
          style={{ marginTop: "10px" }}
          disabled={loading}
        >
          Forgot Password
        </button>
      </div>
    </div>
  );
};

export default Login;
